export class CaseFilter {
  patient_id: string;
  practice_id: any;
  department_id: string;
  ward: string;
  status_id: string;
  date: string;
  page: '1'
}
